/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerStationDto } from './PartnerStationDto';
import {
    PartnerStationDtoFromJSON,
    PartnerStationDtoFromJSONTyped,
    PartnerStationDtoToJSON,
} from './PartnerStationDto';
import type { PartnerVehicleCategoryData } from './PartnerVehicleCategoryData';
import {
    PartnerVehicleCategoryDataFromJSON,
    PartnerVehicleCategoryDataFromJSONTyped,
    PartnerVehicleCategoryDataToJSON,
} from './PartnerVehicleCategoryData';

/**
 * 
 * @export
 * @interface PartnerData
 */
export interface PartnerData {
    /**
     * 
     * @type {PartnerStationDto}
     * @memberof PartnerData
     */
    partnerStation: PartnerStationDto;
    /**
     * 
     * @type {Array<PartnerVehicleCategoryData>}
     * @memberof PartnerData
     */
    vehicleCategoryData: Array<PartnerVehicleCategoryData>;
}

/**
 * Check if a given object implements the PartnerData interface.
 */
export function instanceOfPartnerData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partnerStation" in value;
    isInstance = isInstance && "vehicleCategoryData" in value;

    return isInstance;
}

export function PartnerDataFromJSON(json: any): PartnerData {
    return PartnerDataFromJSONTyped(json, false);
}

export function PartnerDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partnerStation': PartnerStationDtoFromJSON(json['partnerStation']),
        'vehicleCategoryData': ((json['vehicleCategoryData'] as Array<any>).map(PartnerVehicleCategoryDataFromJSON)),
    };
}

export function PartnerDataToJSON(value?: PartnerData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partnerStation': PartnerStationDtoToJSON(value.partnerStation),
        'vehicleCategoryData': ((value.vehicleCategoryData as Array<any>).map(PartnerVehicleCategoryDataToJSON)),
    };
}

